export const DAZ_DEFAULT_ICON =
  'https://dazroupaz.vteximg.com.br/arquivos/favicon.svg'
